import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import appStore from '@/store/app';
import erpStore from '@/store/erp';
import { ErpOrder, SelectItem } from '@/types';
import CardComponent from '@/components/CardComponent';
import CustomToolbar from '@/components/CustomToolbar';
import { getMonthName, getCurrentDay, getCurrentMonth, getCurrentYear } from '@/filters';
import { ErpOrdersSearch } from '@/models';

@Component({
    components: { CardComponent, CustomToolbar },
})
export default class ErpOrders extends Vue {

    @Prop({ default: true }) private readonly checkable!: boolean;

    private selected: ErpOrder | null = null;
    private pageSize = this.search.pageSize;
    private pageNumber = this.search.pageNumber;
    private day = this.search.day;
    private month = this.search.month;
    private year = this.search.year;
    private onlyForToday = this.search.onlyForToday;

    get loading(): boolean {
        return appStore.isLoading;
    }

    get days(): SelectItem<number>[] {
        return Array.from<number, SelectItem<number>>({ length: 31 }, (x, i) => new SelectItem<number>(1 + i, (1 + i).toString()));
    }

    get months(): SelectItem<number>[] {
        return Array.from<number, SelectItem<number>>({ length: 12 }, (x, i) => new SelectItem<number>(1 + i, getMonthName(1 + i)));
    }

    get years(): SelectItem<number>[] {
        const firstYear = getCurrentYear();
        return Array.from<number, SelectItem<number>>({ length: 16 }, (x, i) => new SelectItem<number>(firstYear - i, (firstYear - i).toString()));
    }

    get orders(): ErpOrder[] {
        return erpStore.orders;
    }

    get total(): number {
        return erpStore.totalOrders;
    }

    get search(): ErpOrdersSearch {
        return erpStore.ordersSearch;
    }

    private async created() {
        if (!this.orders || this.total === 0) {
            await this.fetchOrdersAsync();
        }
    }

    private async mounted() {
        await appStore.activateMenuById({ rootId: 300, subMenuId: 301 });
    }

    @Watch('onlyForToday', { immediate: false, deep: false })
    private async onOnlyForTodayChanged(value: boolean, previousValue?: boolean) {

        if (previousValue === undefined) return;

        if (this.onlyForToday) {
            this.search.day = getCurrentDay();
            this.search.month = getCurrentMonth();
            this.search.year = getCurrentYear();
        } else {
            this.search.day = 1;
        }
        this.search.onlyForToday = value;
        this.search.pageNumber = 1;
        await this.fetchOrdersAsync();
    }

    private async onPageChange(page: number) {
        this.search.pageNumber = page;
        await this.fetchOrdersAsync();
    }

    private async refresh() {
        await this.onPageChange(1);
    }

    private async find() {
        this.search.day = this.day;
        this.search.month = this.month;
        this.search.year = this.year;
        await this.onPageChange(1);
    }

    private select(row: ErpOrder, oldRow: ErpOrder | null): void {
        this.selected = row;
    }

    private async fetchOrdersAsync() {
        await erpStore.fetchOrdersAsync(this.search);
    }
}